import { render, staticRenderFns } from "./BusinessPaymentEdit.vue?vue&type=template&id=755a0ed7&scoped=true&"
import script from "./BusinessPaymentEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessPaymentEdit.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPaymentEdit.vue?vue&type=style&index=0&id=755a0ed7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a0ed7",
  null
  
)

export default component.exports